import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function Prebiotics(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual Finalidade?</span>
          </th>
          <th>
            <span>Qual Dose?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré Postura</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.preLay.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.preLay.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.preLay.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
        <tr>
          <td>Pré Pico</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.prePeak.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.prePeak.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.prePeak.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
        <tr>
          <td>Pico de Postura</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layPeak.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layPeak.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layPeak.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
        <tr>
          <td>Postura 01</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal01.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal01.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal01.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
        <tr>
          <td>Postura 02</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal02.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal02.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal02.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
        <tr>
          <td>Postura 03</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal03.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal03.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal03.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
        <tr>
          <td>Postura 04</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal04.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal04.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal04.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>

        <tr>
          <td>Postura 05</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal05.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal05.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal05.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
        <tr>
          <td>Postura 06</td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal06.product"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder="Digite o Produto"
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal06.reason"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
          <td>
            <Input
              type="inputOnly"
              params="additions.prebiotics.layFinal06.dose"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
